/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 04.08.17.
 */

import React from "react";
import PropTypes from "prop-types";
import {v4 as uuidv4} from "uuid";
import EditController from "./EditController";
import Navigation from "../../../Navigation";
import UiSchema from "../../../UiSchema";
import DataManager from "../../../DataManager/DataManager";
import SchemaRegistry from "../../../services/SchemaRegistry";
import JsonSchema from "../../../JsonSchema";
import {GotoBackAction, PageAction} from "../../../services/PageAction/PageAction";
import {NotificationActions} from "../../../services/Notification/index";

class NewController extends EditController {
    static propTypes = {
        basePath: PropTypes.string.isRequired,
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        schema: PropTypes.instanceOf(UiSchema).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired
    };

    static defaultProps = {};

    getNewUuid() {
        return "urn:uuid:" + uuidv4();
    }

    /**
     * @override
     */
    loadData() {
        this.actions().setEditRecord.defer({clientId: this.getNewUuid()}, false);
    }

    loadingFinished(key, newState, oldState) {
        // If finished action was "get", then copy result to edit buffer.
        switch (newState.action.method) {
            case "post":
                // Data is saved, open "view record" page:
                this.actions().clearEditRecordChangedFlag.defer();
                this.setState({isLeaving: true}, function () {
                    if (this.props.params.isModal) {
                        this.onAction(new GotoBackAction({props: this.props.params}));
                    } else {
                        Navigation.replaceViewResource(this.props.params.resource, newState.currentRecord.id);
                    }
                });
                break;
            default:
                super.loadingFinished(key, newState, oldState);
        }
    }

}

export default NewController;
